import * as React from 'react';
import {loadModules} from 'esri-loader';

export default class PictureMarker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graphic: null
        };
        this.timer = null;
        this.tryCount = 3;
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules(['esri/Graphic', 'esri/geometry/SpatialReference',])
            .then(([Graphic, SpatialReference]) => {
                let point = {
                    type: "point", // autocasts as new Polygon()
                    longitude: this.props.x,
                    latitude: this.props.y,
                    spatialReference: new SpatialReference(this.props.wkid ? this.props.wkid : 3301)
                };

                let markerSymbol = {
                    type: "picture-marker", // autocasts as new SimplePictureSymbol()
                    width: this.props.iconSize && this.props.iconSize.width ? this.props.iconSize.width : '42pt',
                    height: this.props.iconSize && this.props.iconSize.height ? this.props.iconSize.height : '42pt',
                    xoffset: this.props.iconOffset && this.props.iconOffset.x ? this.props.iconOffset.x : 0,
                    yoffset: this.props.iconOffset && this.props.iconOffset.y ? this.props.iconOffset.y : 0,
                    url: this.props.url,
                };

                // Add the geometry and symbol to a new graphic
                const graphic = new Graphic({
                    geometry: point,
                    symbol: markerSymbol,
                    attributes: this.props.attributes ? this.props.attributes : null,
                    popupTemplate: this.props.content ? this.props.content : null,
                });

                this.setState({graphic});

                if (this.props.layerId) {
                    const layer = this.props.map.findLayerById(this.props.layerId);
                    if (layer)
                        layer.graphics.add(graphic);
                    else
                        this.timer = setInterval(() => {this.addGraphic(graphic);}, 1000);
                } else {
                    this.props.view.graphics.add(graphic);
                }
            }).catch((err) => console.error(err));
    }

    addGraphic = (graphic) => {
        const layer = this.props.map.findLayerById(this.props.layerId);
        if (layer) {
            layer.graphics.add(graphic);
            clearInterval(this.timer);
            this.timer = null;
        } else {
            this.tryCount--;
        }
        if (this.tryCount < 1) {
            clearInterval(this.timer);
            this.timer = null;
            console.error('Cannot add graphic to map');
        }
    };

    componentWillUnmount() {
        if (this.props.layerId) {
            const map = this.props.map,
                layer = (map) ? map.findLayerById(this.props.layerId) : null;
            if (layer && layer.graphics) {
                layer.graphics.remove(this.state.graphic);
            }
        } else {
            this.props.view.graphics.remove(this.state.graphic);
        }
    }
}
